module.exports = __webpack_public_path__ + "img/145.8a3f23db.png";